import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const PrivateRoute = ({
  setLoginModalOpen,
  setModalOpen,
  children,
  ...rest
}) => {
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  if (loading) {
    return (
      <div className="spinner">
        <h6>loading...</h6>;
      </div>
    );
  }

  if (!user) {
    return setLoginModalOpen(true);
  } else if (user === null && user === undefined) {
    navigate("/");
  }
  return children;
};

export default PrivateRoute;
